import { createAction } from '@reduxjs/toolkit';
import { createPromiseAction } from '../../utils/saga-promise';

export const setDeviceChecksum = createAction('dvm/SET_DEVICE_CHECKSUM');
export const fetchDeviceChecksum = createPromiseAction(
  'dvm/FETCH_DEVICE_CHECKSUM'
);
